import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    name: "",
    token: "",
    notifytimeoutshort: 2000,
    notifytimeoutmedium: 5000,
    notifytimeoutlong: 10000,
    simplenotification: "SIMPLENOTIFICATION",
    timednotification: "TIMEDNOTIFICATION"
  },
  mutations: {
    updateName(state, name) {
      state.name = name;
    },
    updateToken(state, token) {
      state.token = token;
    }
  },
  getters: {
    getName: state => {
      return state.name;
    },
    getToken: state => {
      return state.token;
    }
  },
  actions: {}
});
